import React, { useState } from 'react';
import styled from 'astroturf/react';
import { Body } from 'js/design_system/Body';
import { LikesMenu } from 'js/social/UserListMenu/LikesMenu';
import { ResourceType } from 'js/social/shared/types';
import { LinkButton } from 'js/social/shared/design_system/LinkButton';
import _Container from "Cta-Container.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/Comment/Cta.tsx?styleId=Container";
import _Separator from "Cta-Separator.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/Comment/Cta.tsx?styleId=Separator";
import _CountText from "Cta-CountText.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/Comment/Cta.tsx?styleId=CountText";


const Container = /*#__PURE__*/styled("div", null, {
  displayName: "Container",
  styles: _Container
});

const Separator = /*#__PURE__*/styled(Body, null, {
  displayName: "Separator",
  styles: _Separator
});

const CountText = /*#__PURE__*/styled(Body, null, {
  displayName: "CountText",
  styles: _CountText
});

interface Props {
  id: number | string;
  liked: boolean;
  likeCount: number;
  replyCount: number;
  className?: string;
  likeComment: () => Promise<void>;
  unlikeComment: () => Promise<void>;
  onReplyClick: () => void;
  onReplyCountClick: () => void;
}

const Cta: React.FunctionComponent<Props> = ({
  id,
  liked,
  likeCount,
  replyCount,
  className,
  likeComment,
  unlikeComment,
  onReplyClick,
  onReplyCountClick,
}) => {
  const [disableLike, setDisableLike] = useState(false);

  const onLikeClicked = () => {
    setDisableLike(true);
    likeComment().finally(() => setDisableLike(false));
  };
  const onUnlikeClicked = () => {
    setDisableLike(true);
    unlikeComment().finally(() => setDisableLike(false));
  };

  return (
    <Container className={className}>
      <LinkButton
        disabled={disableLike}
        onClick={liked ? onUnlikeClicked : onLikeClicked}
      >
        {liked ? 'Liked' : 'Like'}
      </LinkButton>
      {likeCount > 0 && (
        <LikesMenu resourceId={id} resourceType={ResourceType.Comment}>
          <CountText size="sm">{likeCount}</CountText>
        </LikesMenu>
      )}

      <Separator size="sm">•</Separator>

      <LinkButton onClick={onReplyClick}>Reply</LinkButton>
      {replyCount > 0 && (
        <CountText size="sm" onClick={onReplyCountClick}>
          {replyCount}
        </CountText>
      )}
    </Container>
  );
};

export default Cta;
